import { Compressor } from "components/modules/Editors/Compressor/Compressor";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import type { GetStaticProps } from "next";
import Head from "next/head";
import { commonLanguageFiles } from "client/config";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { translateFunc } from "client/utils/translateFunc";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { RouteNames } from "@/RouteNames";

const CompressEditor = () => {
    return (
        <>
            <Head>
                <title>{translateFunc("page-title")}</title>
            </Head>
            <ReduxProvider>
                <Compressor toolPathName={RouteNames.imageCompressor} />
            </ReduxProvider>
        </>
    );
};

const files = ["compressor-editor", "uploader", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <CompressEditor />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
